import { TrilogyColor, getColorStyle } from '../facets/Color';
/**
 * Typo color
 */
export var TypographyColor;
(function (TypographyColor) {
    /** @deprecated v4 => use TEXT_MAIN instead */
    TypographyColor["TEXT_PRIMARY"] = "has-text-primary";
    /** @deprecated v4 => use TEXT_MAIN instead */
    TypographyColor["TEXT_SECONDARY"] = "has-text-secondary";
    /** @deprecated v4 => use TEXT_MAIN instead */
    TypographyColor["TEXT_TERTIARY"] = "has-text-tertiary";
    /** @deprecated v4 => use TEXT_MAIN instead */
    TypographyColor["TEXT_QUATERNARY"] = "has-text-quaternary";
    TypographyColor["TEXT_INFO"] = "has-text-info";
    TypographyColor["TEXT_SUCCESS"] = "has-text-success";
    TypographyColor["TEXT_WARNING"] = "has-text-warning";
    /** @deprecated v4 => removed use TEXT_ERROR*/
    TypographyColor["TEXT_DANGER"] = "has-text-danger";
    TypographyColor["TEXT_ERROR"] = "has-text-error";
    /** @deprecated v4 => use TEXT_NEUTRAL_DARK instead */
    TypographyColor["TEXT_GREY_DARK"] = "has-text-grey-dark";
    /** @deprecated v4 => use TEXT_NEUTRAL instead */
    TypographyColor["TEXT_GREY"] = "has-text-grey";
    /** @deprecated v4 => use TEXT_NEUTRAL instead */
    TypographyColor["TEXT_GREY_LIGHT"] = "has-text-grey-light";
    /** @deprecated v4 => use TEXT_NEUTRAL instead */
    TypographyColor["TEXT_GREY_LIGHTER"] = "has-text-grey-lighter";
    TypographyColor["TEXT_WHITE"] = "has-text-white";
})(TypographyColor || (TypographyColor = {}));
/**
 * Typography Color Method (TYPO)
 * @param typo {String} TypographyColor
 * @param inverted {Boolean} Inverted color if isset default : false
 */
export const setTypographyColor = (typo = '', inverted = false) => {
    return ((Array.isArray(typo) && typo.includes(TypographyColor.TEXT_PRIMARY)
        ? getColorStyle(TrilogyColor.PRIMARY)
        : typo === TypographyColor.TEXT_PRIMARY && getColorStyle(TrilogyColor.PRIMARY)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_SECONDARY)
            ? getColorStyle(TrilogyColor.SECONDARY)
            : typo === TypographyColor.TEXT_SECONDARY && getColorStyle(TrilogyColor.SECONDARY)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_INFO)
            ? getColorStyle(TrilogyColor.INFO)
            : typo === TypographyColor.TEXT_INFO && getColorStyle(TrilogyColor.INFO)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_TERTIARY)
            ? getColorStyle(TrilogyColor.TERTIARY)
            : typo === TypographyColor.TEXT_TERTIARY && getColorStyle(TrilogyColor.TERTIARY)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_QUATERNARY)
            ? getColorStyle(TrilogyColor.SUCCESS)
            : typo === TypographyColor.TEXT_QUATERNARY && getColorStyle(TrilogyColor.SUCCESS)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_SUCCESS)
            ? getColorStyle(TrilogyColor.SUCCESS)
            : typo === TypographyColor.TEXT_SUCCESS && getColorStyle(TrilogyColor.SUCCESS)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_WARNING)
            ? getColorStyle(TrilogyColor.WARNING)
            : typo === TypographyColor.TEXT_WARNING && getColorStyle(TrilogyColor.WARNING)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_DANGER)
            ? getColorStyle(TrilogyColor.DANGER)
            : typo === TypographyColor.TEXT_DANGER && getColorStyle(TrilogyColor.DANGER)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_ERROR)
            ? getColorStyle(TrilogyColor.ERROR)
            : typo === TypographyColor.TEXT_ERROR && getColorStyle(TrilogyColor.ERROR)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_GREY_DARK)
            ? getColorStyle(TrilogyColor.GREY_DARK)
            : typo === TypographyColor.TEXT_GREY_DARK && getColorStyle(TrilogyColor.GREY_DARK)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_GREY)
            ? getColorStyle(TrilogyColor.GREY)
            : typo === TypographyColor.TEXT_GREY && getColorStyle(TrilogyColor.GREY)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_GREY_LIGHT)
            ? getColorStyle(TrilogyColor.GREY_LIGHT)
            : typo === TypographyColor.TEXT_GREY_LIGHT && getColorStyle(TrilogyColor.GREY_LIGHT)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_GREY_LIGHTER)
            ? getColorStyle(TrilogyColor.GREY_LIGHTER)
            : typo === TypographyColor.TEXT_GREY_LIGHTER && getColorStyle(TrilogyColor.GREY_LIGHTER)) ||
        (Array.isArray(typo) && typo.includes(TypographyColor.TEXT_WHITE)
            ? getColorStyle(TrilogyColor.WHITE)
            : typo === TypographyColor.TEXT_WHITE && getColorStyle(TrilogyColor.WHITE)) ||
        (inverted && !typo && getColorStyle(TrilogyColor.WHITE)) ||
        getColorStyle(TrilogyColor.TERTIARY));
};
//# sourceMappingURL=TypographyColor.js.map